// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.att-table-col-header[data-v-8f5b6268] {\n    cursor: pointer;\n}\n.attestation-item-link[data-v-8f5b6268] {\n    color: #2185d0;\n}\n.attestation-item-link[data-v-8f5b6268]:hover {\n    text-decoration: underline !important;\n    cursor: pointer !important;\n}\n.no-items-found-message[data-v-8f5b6268] {\n    padding: 2em 2em !important;\n    text-align: center !important;\n}\n", ""]);
// Exports
module.exports = exports;
